import Hashtag from "../models/Hashtag";
import Specifics from "../models/Specifics";

export default class Vacancy {
  constructor(
    _id,
    title,
    info,
    salary,
    specific,
    date_of_create,
    views,
    rating,
    image_url,
    company_name,
    company_specifics,
    company_id,
    is_remote,
    is_public,
    company_logo_url,
    longitude,
    latitude,
    image_base64,
    preview_image_base64,
    address,
    city_id,
    partner_url,
    experience,
    hashtags,
    likes,
    response_count,
    type,
    vacancy_owner,
    is_email_handling,
    is_liked,
    is_responded,
    company_about_company,
    company_region_id,
    company_url_of_background,
    is_our_vacancy
  ) {
    this._id = _id;
    this.id = _id;
    this.title = title;
    this.info = info;
    this.salary = salary;
    this.specific = specific;
    this.date_of_create = date_of_create;
    this.views = views;
    this.rating = rating;
    this.image_url = image_url;
    this.company_name = company_name;
    this.company_specifics = company_specifics;
    this.company_id = company_id;
    this.is_remote = is_remote;
    this.is_public = is_public;
    this.company_logo_url = company_logo_url;
    this.longitude = longitude;
    this.latitude = latitude;
    this.image_base64 = image_base64;
    this.preview_image_base64 = preview_image_base64;
    this.address = address;
    this.city_id = city_id;
    this.partner_url = partner_url;
    this.experience = experience;
    this.hashtags = hashtags || [];
    this.likes = likes || 0;
    this.response_count = response_count || 0;
    this.type = type || 0;
    this.vacancy_owner = vacancy_owner;
    this.is_email_handling = is_email_handling;
    this.is_liked = is_liked || false;
    this.is_responded = is_responded || false;
    this.company_about_company = company_about_company;
    this.company_region_id = company_region_id;
    this.company_url_of_background = company_url_of_background;
    this.is_our_vacancy = is_our_vacancy ?? false;
  }

  static fromJson(json) {
    const id = json._id || json.id;

    return new Vacancy(
      id,
      json.title,
      json.info,
      json.salary,
      json.specific
        ? Specifics.fromJson(json.specific)
        : null,
      json.date_of_create,
      json.views,
      json.rating,
      json.image_url,
      json.company_name,
      json.company_specifics,
      json.company_id,
      json.is_remote,
      json.is_public,
      json.company_logo_url,
      json.longitude,
      json.latitude,
      json.image_base64,
      json.preview_image_base64,
      json.address,
      json.city_id,
      json.partner_url,
      json.experience,
      json.hashtags
        ? json.hashtags.map(Hashtag.fromJson)
        : [],
      json.likes || 0,
      json.response_count || 0,
      json.type || 0,
      json.vacancy_owner,
      json.is_email_handling,
      json.is_liked || false,
      json.is_responded || false,
      json.company_about_company,
      json.company_region_id,
      json.company_url_of_background,
      json.is_our_vacancy ?? false
    );
  }
}

export {
  Specifics,
  Hashtag
};